import Link from "next/link";
import Nav from "./Nav";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Router, { useRouter } from "next/router";
import { NotificationManager } from "react-notifications";
import { setRecentOrders } from "../store/actions/shop";
import { useState, useEffect } from "react";
import { addToCart, setTotalPrice } from "../store/actions/shop";
import axiosInstance from "../config/axios";
const NavBar = (orderingTime, deliveryOrderingTime) => {
  const router = useRouter();
  const hiddenRoutes = ["/menu"];
  const allCart = useSelector((state) => state.shop.cart);
  const allTotalPrice = useSelector((state) => state.shop.totalPrice);
  const [showCart, setShowCart] = useState(false);
  const [productCart, setProductCart] = useState(allCart);
  const [minOrderAmount, setMinOrderAmount] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const toggleCart = () => {
    setShowCart((prev) => !prev);
  };
  let token = useSelector((state) => state.auth.token);

  // useEffect(() => {
  //     const fetchOrderingTime = async () => {
  //         try {
  //             const { data : {data} } = await axiosInstance.get(`settings/get-order-times`);
  //                 console.log({data})
  //             const currentTime = new Date().getHours();
  //              openingHour = +data.opening_time;
  //              closingHour = +data.closing_time;

  //             const orderTimeState = currentTime >= openingHour && currentTime < closingHour;
  //             // const orderTimeState = true;
  //             // console.log({orderTimeState});
  //             setOrderingTime(orderTimeState);
  //         } catch (error) {
  //             console.log(error)
  //         }
  //     }
  //     fetchOrderingTime();
  // }, [orderingTime]);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Bootstrap md breakpoint
    };

    // Check on initial load
    checkScreenSize();

    // Listen for window resize
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchMinPrice = async () => {
        try {
          const {
            data: { data: res },
          } = await axiosInstance.get("settings/get-min-order-amount");

          setMinOrderAmount(Number(res.min_order_amount));
        } catch (e) {
          // console.log(e);
        }
      };

      fetchMinPrice();
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const testauth = useSelector((state) => state.auth);
  let user = useSelector((state) => state.auth.user) || {};

  //console.log("testingAuth", testauth);

  const dispatch = useDispatch();
  const currentPath = router.pathname;

  const logoutHandler = () => {
    dispatch(logout(token));
    !loggedIn ? null : NotificationManager.success("Logged out", "", 3000);
    dispatch(setRecentOrders([]));
    if (
      router.pathname.includes("/profile") ||
      router.pathname.includes("/wallet")
    ) {
      Router.push("/signup");
    }
  };

  const signupHandle = () => {
    localStorage.removeItem("checkoutToLogin");
  };

  const showClosed = () => {
    if (orderingTime.orderingTime === false) {
      // $('#storeClosed').modal('show');
      return;
    } else {
      Router.push("/");
      return;
    }
  };

  const updateQuantityHandle = (cartIndex, action) => {
    const cartCopy = [...allCart];
    const price = cartCopy[cartIndex].salePrice || cartCopy[cartIndex].price;

    // increment or decrement
    if (action === "increment") {
      cartCopy[cartIndex].quantity += 1;
    } else if (action === "decrement" && cartCopy[cartIndex].quantity > 1) {
      cartCopy[cartIndex].quantity -= 1;
    }

    // recalculate total
    cartCopy[cartIndex].totalPrice = cartCopy[cartIndex].quantity * price;

    // update state + redux
    setProductCart(cartCopy);
    dispatch(addToCart(cartCopy));
    dispatch(setTotalPrice());
  };
  const deleteProductCartHandler = (index, id) => {
    const cartSlice = [...allCart];
    cartSlice.splice(index, 1);
    //setProductCart(cartSlice);
    dispatch(addToCart(cartSlice));
    dispatch(setTotalPrice());
  };
  const totalSum = allCart.reduce((sum, item) => sum + item.totalPrice, 0);

  return (
    <>
      <style jsx>{`
        
        .cart-badge {
          position: absolute;
          top: -8px;
          left: 26px;
          color: #fff;
          border-radius: 60%;
          background: transparent;
          padding: 2px 6px;
          font-size: 1.75rem;
          font-weight: bold;
          line-height: 1;
          min-width: 18px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          
        }
        
  }
      `}</style>
      <nav id="navbar_top" className="navbar navbar-expand-lg">
        <Link href="/">
          <a className="navbar-brand">
            <img
              src="/images/logo.svg"
              alt="Kilimanjaro-logo"
              width={160}
              height={40}
              fetchpriority="high"
            />
          </a>
        </Link>
        <div className="d-flex align-items-center d-lg-none ml-auto">
          <div className="mobile-cart position-relative  d-lg-none">
            <a
              className="nav-link p-0 position-relative mr-4"
              onClick={toggleCart}
            >
              <img
                src="/images/icon/new-cart.svg"
                alt="cart-logo"
                width={35}
                height={30}
                style={{
                  cursor: "pointer",
                  width: "35px",
                  height: "30px",
                  flexShrink: 0,
                }}
              />
              <span className="cart-badge">{allCart.length}</span>
            </a>

            {showCart && (
              <section>
                <div className="cart-dropdown p-3 bg-white border rounded shadow-sm">
                  <div className="d-flex justify-content-between align-items-center mb-2 border-bottom">
                    <h6 className="m-2 text-center flex-grow-1">Cart</h6>
                    <span
                      className="close text-muted mb-2"
                      style={{ cursor: "pointer", fontSize: "2.5rem" }}
                      onClick={() => setShowCart(false)}
                    >
                      &times;
                    </span>
                  </div>

                  <div className="cart-items-wrapper">
                    {!allCart.length > 0 ||
                      (allTotalPrice < minOrderAmount && (
                        <p className="mb-2">
                          A minimum order of ₦{minOrderAmount.toLocaleString()}{" "}
                          is required before checking out. Current cart's total
                          is: ₦
                          {allTotalPrice === null
                            ? "0"
                            : allTotalPrice.toLocaleString()}
                        </p>
                      ))}
                    {allCart.length > 0 ? (
                      <>
                        {allCart.map((cart, index) => (
                          <div
                            className="cart-items mb-3 w-100"
                            key={`Prod-cart${cart?.product.id || index}`}
                          >
                            <div className="d-flex justify-content-between">
                              <div className="d-flex">
                                <img
                                  src={cart.product?.image_url}
                                  alt={cart.product.product}
                                  className="mr-3"
                                  width={30}
                                  height={30}
                                />
                                <p>{cart?.product?.product}</p>
                              </div>
                              <p>{"₦" + cart?.totalPrice?.toLocaleString()}</p>
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <div>
                                <span
                                  className="increment mr-3"
                                  onClick={() =>
                                    updateQuantityHandle(index, "decrement")
                                  }
                                >
                                  –
                                </span>
                                <span className="font-weight-bold mr-3">
                                  {cart.quantity}
                                </span>
                                <span
                                  className="increment"
                                  onClick={() =>
                                    updateQuantityHandle(index, "increment")
                                  }
                                >
                                  ＋
                                </span>
                              </div>
                              <a>
                                <i
                                  className="fa fa-trash"
                                  style={{ color: "#DC042A", fontSize: "20px" }}
                                  onClick={() =>
                                    deleteProductCartHandler(
                                      index,
                                      cart.product.id,
                                    )
                                  }
                                />
                              </a>
                            </div>
                          </div>
                        ))}

                        <div className="d-flex justify-content-between mb-3">
                          <p className="font-weight-bold">Subtotal</p>
                          <p className="h4 font-weight-bold mr-0">
                            {"₦" + new Intl.NumberFormat().format(totalSum)}
                          </p>
                        </div>

                        <div className="d-flex flex-column">
                          <button
                            className="btn w-100 mb-2"
                            onClick={() => {
                              setShowCart(false);
                              Router.push("/cart");
                            }}
                          >
                            <span className="text">View or Edit</span>
                          </button>
                          <button
                            className="btn w-100"
                            onClick={() => {
                              setShowCart(false);
                              Router.push("/checkout");
                            }}
                            disabled={allTotalPrice < minOrderAmount}
                          >
                            <span className="text">Proceed to Checkout</span>
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <p className="empty-text mb-3 mt-4 text-center">
                          Your cart is empty
                        </p>
                        <button
                          className="btn w-100"
                          onClick={() => {
                            setShowCart(false);
                            Router.push("/");
                          }}
                        >
                          <span className="text">Continue shopping</span>
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </section>
            )}
          </div>

          <button
            className="navbar-toggler pr-0"
            id="show-nav"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <img
              className="navbar-toggler-icon"
              src="/images/icon/menu-rd.webp"
              alt="Menu icon"
              //width={50}
              //height={50}
              style={{ width: "30px", height: "25px", flexShrink: 0 }}
            />
          </button>
        </div>

        <Nav
          orderingTime={orderingTime}
          deliveryOrderingTime={deliveryOrderingTime}
        />
      </nav>

      {/* {!router.asPath.startsWith("/menu") && (
  <section className="">
    <img
      src="/images/val-top-banner.png"
      className="xmas-banner"
      alt="val-banner"
    />
  </section>
)} */}

      {/* {
  router.pathname === "/"  && isMobile && (
    <section >
    <div className="food-banner-mask">
  <Image
    src="/images/food-1-resized.webp"
    alt="food banner"
    layout="fill"
    objectFit="cover"
    priority
    sizes="(max-width: 768px) 412px, 1px"
    className="food-banner"
    quality={60}
  />
</div>
  </section>
  )

} */}
    </>
  );
};

export default NavBar;
